import { useState } from "react";
import { CalendarDays, CalendarClock, Fingerprint, ClipboardCheck, BarChart3 } from "lucide-react";
import { useT } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AttendanceDay from "@/pages/AttendanceDay";
import AttendanceCorrection from "@/pages/AttendanceCorrection";
import FingerspotAttendance from "@/pages/FingerspotAttendance";
import EndOfDayCheck from "@/pages/EndOfDayCheck";
import MonthlyAnalytics from "@/pages/MonthlyAnalytics";

// "Absensi" = attendance hub. Admin sees all tabs; sub-admin (Monika) sees Daily / Analytics / Correction.
const DEF = {
  harian: { icon: CalendarDays, labelKey: "att.tabDaily", C: AttendanceDay },
  sidik: { icon: Fingerprint, labelKey: "att.tabFingerprint", C: FingerspotAttendance },
  eod: { icon: ClipboardCheck, labelKey: "att.tabEod", C: EndOfDayCheck },
  analitik: { icon: BarChart3, labelKey: "att.tabAnalytics", C: MonthlyAnalytics },
  koreksi: { icon: CalendarClock, labelKey: "att.tabCorrection", C: AttendanceCorrection },
};
const ADMIN_ORDER = ["harian", "sidik", "eod", "analitik", "koreksi"];
const SUBADMIN_ORDER = ["harian", "analitik", "koreksi"];

export default function Absensi() {
  const { t } = useT();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin" || user?.role === "viewer";
  const order = isAdmin ? ADMIN_ORDER : SUBADMIN_ORDER;
  const [tab, setTab] = useState(order[0]);

  const triggerClass =
    "flex shrink-0 items-center gap-1.5 rounded-full px-4 py-2 text-[13.5px] font-medium text-[#6E6E73] transition-all data-[state=active]:bg-white data-[state=active]:text-[#1D1D1F] data-[state=active]:shadow-[0_2px_8px_rgba(0,0,0,0.08)]";

  return (
    <div data-testid="absensi-page" className="w-full space-y-5">
      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList
          data-testid="absensi-tabs"
          className="flex h-auto w-full items-center justify-start gap-1 overflow-x-auto rounded-full border border-white/40 bg-white/40 p-1 ring-1 ring-inset ring-white/40 backdrop-blur-xl"
        >
          {order.map((k) => {
            const Icon = DEF[k].icon;
            return (
              <TabsTrigger key={k} value={k} data-testid={`absensi-tab-${k}`} className={triggerClass}>
                <Icon className="h-4 w-4" /> {t(DEF[k].labelKey)}
              </TabsTrigger>
            );
          })}
        </TabsList>
        {order.map((k) => {
          const C = DEF[k].C;
          return (
            <TabsContent key={k} value={k} className="mt-5">
              <C />
            </TabsContent>
          );
        })}
      </Tabs>
    </div>
  );
}
